<template v-else-if="product.id == 'info'">
    <div class="slider-item-content info" :style="styles">

        <template v-if="loading">
            <MuffinLoader class="contained" />
        </template>
        <template v-else-if="hasUrl">
            <a class="link" @click="handleClickClaim">
                <i v-if="isGuest" class="prz-user"></i> 
                {{content.claimBtnText}}
            </a>
        </template>
        <template v-else>
            <p v-html="content.phrase1"></p>
            <p class="coupon-code">
                <template v-if="!copied">
                    {{ content.coupon }} <i class="prz-copy" @click="copyToClipboard"></i> 
                </template>
                <template v-else>
                    {{ content.txtCopied }} 
                </template>
            </p>
            <p v-html="content.phrase2"></p>
        </template>
    </div>
</template>   

<script>
import copyToClipboard from '@/Utilities/copyToClipboard';
import request from '@/Utilities/httpRequest';
import MuffinLoader from '@/components/Muffin/Loader';
import {store} from '@/store/diamond';

export default {
    store,
    name: 'DiamondInfo',
    components: {
        MuffinLoader
    },
    props: {
        content: {
            type: Object,
            default: null,
        },
        borderWidth: null
    },
    data() {
        return {
            copied: false,
            loading: false,
        }
    },
    computed: {
        styles(){
            let styles = {};
            if(this.borderWidth){
                styles['border-width'] = borderWidth + 'px';
            }
            if(this.content.bgColor){
                styles['background-color'] = this.content.bgColor;
            }
            return styles;
        },
        hasUrl(){
            return this.content.claimBtnUrl ? true : false;
        },
        url(){
            const params = this.content.claimParams;
            const qs = Object.keys(params)
                    .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
                    .join('&')
            return this.content.claimBtnUrl + '?' + qs;
        },
        isGuest(){
            return this.content.isGuest;
        },
    },
    watch: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
        copyToClipboard(){
            const code = this.content.coupon;
            if(code && this.copied === false){
                let copy = copyToClipboard.copy(code);
                if (copy) {
                    //console.log('code copied: ', code);
                    this.copied = true;
                    setTimeout(() => { this.copied = false; }, 3000);
                }
            }
        },
        async handleClickClaim(event){
            this.loading = true;
            const { data } = await request.get(this.url);
            //console.log('handleClickClaim', data);
            if(!data || data.hasError){
                // something went wrong reload page (offer may be unavailable, user logged out, etc)
                document.location.reload();
            }

            if(data && data.hasOwnProperty('loginDesktop') && data.loginDesktop){
                // desktop has tricky modal for login
                if(typeof accountAuth !== 'undefined'){
                    // stop showing loader
                    this.loading = false;
                    // close diamond modal
                    this.$store.dispatch('setModalState', 'closed');
                    // show diamond icon in header
                    document.getElementById('diamondDktMenu').classList.remove('open');
                    // open login modal 
                    setTimeout(() => {
                        // open login modal 
                        accountAuth.openLogin(data.hasOwnProperty('urlParams') ? data.urlParams : null);
                    }, 300);

                    return;
                }
            }

            if(data.hasOwnProperty('url')){
                document.location.href = data.url;
            }
        },
    }
};
</script>

<style scoped>

</style>